import * as React from "react";
import { SVGProps } from "react";

const Trueusd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="TUSD"
    x={0}
    y={0}
    viewBox="0 0 500 500"
    {...props}
  >
    <style>{".st0{fill:#002868}.st1{fill:#fff}"}</style>
    <path
      id="Coin_BG"
      d="M250 500C112.5 500 0 387.5 0 250S112.5 0 250 0s250 112.5 250 250-112.5 250-250 250z"
      className="st0"
    />
    <path
      id="BG_1_"
      d="M376 400H124c-13.2 0-24-10.8-24-24V124c0-13.2 10.8-24 24-24h252c13.2 0 24 10.8 24 24v252c0 13.2-10.8 24-24 24z"
      className="st1"
    />
    <path
      d="M158.54 369.8c-.79 0-1.43-.72-1.43-1.51v-40.31c0-.79-.64-1.51-1.43-1.51h-14.23c-.8 0-1.51-.64-1.51-1.43v-7.79c0-.79.72-1.51 1.51-1.51h43.8c.79 0 1.51.71 1.51 1.51v7.79c0 .79-.72 1.43-1.51 1.43H171.1c-.79 0-1.51.71-1.51 1.51v40.31c0 .79-.64 1.51-1.43 1.51h-9.62zm71.94-52.55c0-.79.64-1.51 1.43-1.51h9.54c.79 0 1.51.71 1.51 1.51v27.51c0 16.3-9.22 25.76-23.85 25.76-14.55 0-23.69-9.46-23.69-25.76v-27.51c0-.79.64-1.51 1.43-1.51h9.54c.79 0 1.51.71 1.51 1.51v27.9c0 8.03 4.13 13.75 11.29 13.75s11.29-5.72 11.29-13.75v-27.9zm56.29 16.14c-1.27 0-1.67-.48-2.15-1.43-1.67-3.9-5.33-6.36-10.89-6.36-5.01 0-9.22 1.75-9.22 5.09 0 3.66 3.9 5.17 12.48 6.2 13.04 1.51 20.51 5.49 20.51 15.82 0 11.61-10.18 17.73-23.21 17.73-11.29 0-20.99-5.49-22.5-17.01-.16-1.11.4-1.51 1.51-1.51h8.75c1.11 0 1.75.48 2.07 1.35 1.19 3.82 5.25 6.76 11.13 6.76 5.17 0 9.7-1.91 9.7-5.96 0-4.85-4.77-5.72-14.31-6.92-10.97-1.43-18.6-4.61-18.6-14.71s8.67-17.33 22.26-17.33c12.24 0 20.75 6.6 22.5 16.46.24 1.11-.08 1.83-1.27 1.83h-8.76zm21.54 36.41c-.79 0-1.43-.72-1.43-1.51v-51.04c0-.79.64-1.51 1.43-1.51h21.62c16.06 0 28.54 11.05 28.54 27.19 0 15.9-12.32 26.87-28.54 26.87h-21.62zm21.62-10.74c8.67 0 15.42-6.84 15.42-16.3s-6.76-16.3-15.5-16.3h-8.98c-.79 0-1.43.71-1.43 1.51v29.65c0 .79.64 1.43 1.43 1.43h9.06z"
      className="st0"
    />
    <path
      id="BG"
      d="M392 286H108c-2.2 0-4-1.8-4-4V124c0-11 9-20 20-20h252c11 0 20 9 20 20v158c0 2.2-1.8 4-4 4z"
      className="st0"
    />
    <path
      id="_x7C_"
      d="M264.73 253.56h-26c-1.65 0-3-1.35-3-3v-110c0-1.65 1.35-3 3-3h26c1.65 0 3 1.35 3 3v110c0 1.65-1.35 3-3 3z"
      className="st1"
    />
    <path
      id="_x2014_"
      d="M309 169.56H191c-1.65 0-3-1.35-3-3v-26c0-1.65 1.35-3 3-3h118c1.65 0 3 1.35 3 3v26c0 1.65-1.35 3-3 3z"
      className="st1"
    />
  </svg>
);

export default Trueusd;
